import { Report57Container } from "../../../containers/SupportSystem/Reports/Report57Container";
export function Report57Page() {
    return (
        <Report57Container />
    );

}